import type { FunctionComponent, ReactNode } from 'react';
import { createContext, useContext } from 'react';

/** What a tile shows, for the actions other features add to its header. */
export type UrlTileSubject =
    | { readonly architectureId: string; readonly kind: 'position'; readonly positionId: string }
    | { readonly kind: 'task'; readonly taskId: string }
    | {
          /** The Job Architecture the role or level belongs to. */
          readonly jobArchitectureId: string;
          readonly kind: 'job-level' | 'job-role';
          readonly profileId: string;
          readonly title: string;
      };

/** Renders the header actions a feature adds for a tile's subject, such as prioritizing it. */
export type UrlTileSubjectActionsRenderer = (subject: UrlTileSubject) => ReactNode;

const UrlTileSubjectActionsContext = createContext<UrlTileSubjectActionsRenderer | null>(null);

export const UrlTileSubjectActionsProvider = UrlTileSubjectActionsContext.Provider;

/** The actions other features add for the subject, in the tile header before the tile's own; none outside a provider. */
export const UrlTileSubjectActions: FunctionComponent<{ readonly subject: UrlTileSubject }> = ({ subject }) =>
    useContext(UrlTileSubjectActionsContext)?.(subject) ?? null;
